import "./Login.css"; 
import { Link, useNavigate } from "react-router-dom";
import Button from "../../Components/Button/Button";
import Input from "../../Components/Form/Input/Input";
import LoginOptions from "./LoginOptions";
import Utils from "../../Services/Utills";
import Server, { Get } from "../../Services/Server";
import { toast } from "react-toastify";
import User from "../../Services/User";
import Url from "../../Services/Url";
import logo from "../../Assets/svg/logo.svg";

const Login = () => {
  const navigate = useNavigate();

  const fetchAndShowNotifications = () => {
	try {
	  const roles = User.getRoles() || [];
	  const userRoleIds = [...new Set(roles.map((r) => r.id))];
  
	  Get(Url.notification.current)
		.then((notifications) => {
		  notifications.forEach((notif) => {
			let notifRoleIds = [];
			if (Array.isArray(notif.roleIds)) {
			  notifRoleIds = notif.roleIds;
			} else if (typeof notif.roleIds === "string") {
			  try {
				notifRoleIds = JSON.parse(notif.roleIds);
			  } catch {
				notifRoleIds = [];
			  }
			} else if (notif.roleIds != null) {
			  notifRoleIds = [notif.roleIds];
			}
  
			const hasAccess = notifRoleIds.some((rid) =>
			  userRoleIds.includes(rid)
			);
  
			if (hasAccess) {
			  toast.info(
				<div style={{ fontSize: "14px" }}>
				  <strong style={{ fontSize: "15px", color:"#14b8ff" }}>
					 {notif.title}
				  </strong>
				  <div style={{ marginTop: "4px", color: "#333" }}>
					{notif.message}
				  </div>
				</div>,
				{
				  autoClose: false,
				  closeOnClick: true,
				  draggable: true,
				}
			  );
			}
		  });
		})
		.catch((err) => {
		  console.error("Error fetching notifications:", err);
		});
	} catch (err) {
	  console.error("Error in fetchAndShowNotifications:", err);
	}}
  
  

  const onSubmit = () => {
    Server.login(Utils.FormObject(LoginOptions))
      .then((resp) => {
        toast.success(resp, { theme: "colored" });

        const role = User.getRole();
        navigate("../" + role.base);

        fetchAndShowNotifications();
      })
      .catch((err) => {
        toast.error(err, { theme: "colored" });
      });
  };

  return (
    <div className="LoginPage">
      <div className="LoginLeft">
        <div className="LoginTitle">
          <div>
            <img src={logo} alt="logo" />
          </div>
          PROJECT TRACKER REPORT SYSTEM
        </div>

        <div className="LoginForm">
          <h1>Login</h1>
          {LoginOptions.Fields.map((option, index) => (
            <div key={index}>
              <Input>{option}</Input>
            </div>
          ))}
          <div className="ForgetPWLink">
            <div className="ActiveLink">
              Forget your <Link>password</Link>
            </div>
          </div>
          <div>
            <Button onClick={onSubmit} className="Btn-Mid Active">
              Login
            </Button>
          </div>
        </div>
      </div>
      <div className="LoginRight"></div>
    </div>
  );
};

export default Login;
